<template>
    <span>
        <el-popover placement="bottom" width="1250" @show="initData" trigger="manual" v-model='showPopover'>
        <div id="search-set">
            <ul class="search-list-box">
                <template v-for="(outer, pIndex) in searchList">
                <li v-for="item in outer.list" :class="item.value +'-prop-advanced'" :key="item.name + item.value + pIndex">
                    <span>{{item.name}}</span>
                    <div>
                        <el-input class='text-box' v-if="item.type === 'advanceUser'" v-model="outer.data[item.value]"
                            readonly
                            @keyup.113.native="userDetaliSearch(pIndex,item)"
                            @keyup.enter.native="userDetaliSearch(pIndex,item)"
                            @blur="userDetaliSearch(pIndex,item)"
                            @input="advanceCodeChange(pIndex,item)"
                            @clear="advanceCodeChange(pIndex,item)"
                            :disabled="showState">
                            <template v-slot:append>
                                <el-button :disabled="showState" @click="userDetaliSearch(pIndex,item)" icon="el-icon-search"></el-button>
                            </template>
                            <template v-slot:suffix>
                                <i :disabled="showState" @click="resetAdvanceParams(item.value)" class="el-input__icon el-icon-circle-close" v-if="outer.data[item.value]"></i>
                            </template>
                        </el-input>
                        <el-input class='text-box' v-if="item.type === 'advance'" v-model="outer.data[item.value]"
                            readonly
                            @keyup.113.native="detaliSearch(pIndex,item)"
                            @keyup.enter.native="detaliSearch(pIndex,item)"
                            @input="advanceCodeChange(pIndex,item)"
                            @clear="advanceCodeChange(pIndex,item)"
                            :disabled="showState">
                            <template v-slot:append>
                                <el-button :disabled="showState" @click="detaliSearch(pIndex,item)" icon="el-icon-search"></el-button>
                            </template>
                            <template v-slot:suffix>
                                <i :disabled="showState" @click="resetAdvanceParams(item.value)" class="el-input__icon el-icon-circle-close" v-if="outer.data[item.value]"></i>
                            </template>
                        </el-input>
                        <el-input class='text-box' :disabled="showState" v-if="item.type === 'input'" v-model="outer.data[item.value]"></el-input>
                        <el-select class='text-box' v-model="outer.data[item.value]"
                                  :popper-append-to-body="false"
                                   v-if="item.type === 'select'"
                                   :clearable="_.get(item, 'clearable', true)"
                                   :multipleLimit="item.multipleLimit||0"
                                   :multiple="item.multiple?item.multiple:false"
                                   :filterable="item.filterable"
                                   :disabled="showState"
                                   collapse-tags>
                            <el-option
                                v-for="(val, index) in item.options"
                                :key=index
                                :label="val.label"
                                :value="val.value">
                            </el-option>
                        </el-select>
                        <el-select
                           :popper-append-to-body="false"
                            v-else-if="item.type === 'autocomplete'"
                            :clearable="_.get(item, 'clearable', true)"
                            v-model="outer.data[item.passValue?item.passValue:item.value]"
                            filterable
                            remote
                            :multiple="item.multiple?item.multiple:false"
                            reserve-keyword
                            :placeholder=item.name
                            :remote-method="remoteMethod"
                            @focus="searchDateChange(item)"
                            :loading="searchLoading"
                            :disabled="showState"
                            collapse-tags>
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <addressSelect
                                class='text-box'
                                v-if="item.type === 'addressSelect'"
                                v-model="outer.data[item.value]"
                                :minLayers="item.minLayers"
                                :placeholder="item.name"
                                :basicProps="item.config"
                        ></addressSelect>
                        <mAddressSelect
                                v-if="item.type === 'mAddressSelect'"
                                v-model="outer.data[item.value]"
                                :minLayers="item.minLayers"
                                :placeholder="item.name"
                                :basicProps="item.config"
                                :collapseTags="item.collapseTags"
                        ></mAddressSelect>
                        <addressSelectThree
                                class='text-box'
                                v-if="item.type === 'addressSelect3'"
                                v-model="outer.data[item.value]"
                                :minLayers="item.minLayers"
                                :placeholder="item.name"
                                :basicProps="item.config"
                        ></addressSelectThree>
                       <addressCascader
                        class='text-box'
                                v-if="item.type === 'addressCascader'"
                                v-model="outer.data[item.value]"
                                :minLayers="item.minLayers"
                                :placeholder="item.name"
                                :basicProps="item.config"
                                :triggerEvent="'hover'"
                                :hotData="item.hotData"
                                :showNoChoice="item.showNoChoice"
                        ></addressCascader>
                        <el-date-picker
                                class='date-picker-box'
                                v-if="item.type === 'date'"
                                v-model="searchData[item.value]"
                                size="mini"
                                :clearable="_.get(item, 'clearable', false)"
                                format="yyyy-MM-dd HH:mm"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker
                            class='text-box padding-for-prefix'
                            v-if="item.type === 'time'"
                            v-model="outer.data[item.value]"
                            :clearable="_.get(item, 'clearable', false)"
                            :disabled="showState"
                            size="mini"
                            :format="item.format||'yyyy-MM-dd HH:mm:ss'"
                            :value-format="item.format||'yyyy-MM-dd HH:mm:ss'"
                            :type="item.timeType?item.timeType:'datetimerange'"
                            unlink-panels
                            :placeholder="item.placeholder"
                            range-separator="至"
                            :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始日期'"
                            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束日期'"
                            :picker-options="item.timeType?(item.pickerOptions || {}):(item.pickerOptions || pickerOptions)"
                            :default-time="item.timeType?'':['00:00:00', '23:59:59']">
                        </el-date-picker>
                        <slot :name="item.value + 'AdvanceSlot'" v-if="item.type === 'slot'"></slot>
                    </div>
                </li>
                </template>
            </ul>
            <div v-if="!showState" class="btn-box">
                <div class="text-btn" v-show="resourceCode">
                    <el-button type="text" @click="showStateOpen">自定义搜索条件</el-button>
                </div>
                <div class="btn-btn">
                    <el-button type="primary" @click="search">搜 索</el-button>
                    <el-button type="text" @click="clear">重 置</el-button>
                </div>
            </div>
            <div v-if="showState">
                <p class="line"></p>
                <p>选择添加搜索条件</p>
                <ul class="search-total-box">
                    <li v-for="(item, index) in searchTotalTitle" :key="index">
                        <el-button :class="['btn-width', { 'is-select' : item.select }]" plain @click="btnChange(index)">{{item.name}}</el-button>
                    </li>
                </ul>
                <div class="btn-box">
                    <el-button type="text" @click="cancelSearch">取消</el-button>
                    <el-button type="primary" @click="saveSearch">保存</el-button>
                </div>
            </div>
        </div>
        <advance-dialog ref="advanceDialog" @confirm="detaliSearchSure"></advance-dialog>
        <advance-user ref='advanceUser' @confirm="detaliSearchSure"></advance-user>
        <template v-slot:reference>
            <el-button @click="showPopover = !showPopover;">高级</el-button>
        </template>
    </el-popover>
    <div class="search-set_back" v-show="showPopover" @click.self="showPopover = !showPopover;"></div>
    </span>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import _ from '@/components/lots/utils';
import { dict, longRange, getList } from '../api';
import advanceDialog from '../mAdvanceDialog';
import advanceUser from '@/components/lots/otpAdvanceUser';
import addressSelect from '@/components/lots/otpCascader2';
import mAddressSelect from '../mAddressSelect';
import addressSelectThree from '@/components/lots/otpCascader3';
import addressCascader from '@/components/lots/addressCascader';

export default {
    components: { advanceDialog, addressSelect, mAddressSelect, advanceUser, addressSelectThree, addressCascader },
    props: {
        popPrefix: String,
        advancePrefix: String,
        longPrefix: String,
        searchTotalTitle: {
            type: Array,
            default () {
                return [];
            }
        },
        searchInitList: {
            type: Array,
            default () {
                return [];
            }
        },
        setSearchData: {
            type: Object,
            default () {
                return {};
            }
        },
        searchId: String,
        configurationUrl: String,
        filterable: Boolean,
        initSearchInfo: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data() {
        return {
            searchData: {},
            searchChange: [],
            searchSetList: [],
            selectNum: [],
            showState: false,
            advanceType: 0,
            searchSetTitle: [],
            options: [],
            searchLoading: false,
            selectItem: '',
            showPopover: false,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const start = dayjs().startOf('day').subtract(6, 'd').toDate();
                        const end = dayjs().endOf('day').toDate();
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const start = dayjs().startOf('day').subtract(1, 'M').toDate();
                        const end = dayjs().endOf('day').toDate();
                        picker.$emit('pick', [start, end]);
                    }
                // }, {
                //     text: '最近两个月',
                //     onClick(picker) {
                //         const start = dayjs().startOf('day').subtract(2, 'M').toDate();
                //         const end = dayjs().endOf('day').toDate();
                //         picker.$emit('pick', [start, end]);
                //     }
                }]
            },
            keyMap: {},
            resourceCode: ''
        };
    },
    methods: {
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.path) {
                            this.resourceCode = childrens[i].resourceCode;
                            return childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        btnChange(index) {
            this.searchTotalTitle[index].select = !this.searchTotalTitle[index].select;
            this.searchSetList = [];
            this.selectedShow();
        },
        cancelSearch() {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
            });
            this.showState = false;
        },
        showStateOpen() {
            this.showState = true;
        },
        saveSearch() {
            this.showState = false;
            let searchTotalTitle = [];
            let searchTotalName = [];
            this.searchSetList.forEach(data => {
                searchTotalTitle.push(data.name);
                searchTotalName.push(data.value);
            });
            searchTotalTitle = searchTotalTitle.join(',');
            searchTotalName = searchTotalName.join(',');
            const pramas = {
                'configName': searchTotalName,
                'configNameCn': searchTotalTitle,
                'subjectType': this.searchId,
                'moduleCode': this.resourceCode
            };
            getList.post(this.configurationUrl, pramas).then(() => {
            }).catch(() => {});
        },
        clear() {
            this.searchReset(null, true);
            this.$emit('init-search', null, true);
            this.$emit('on-reset');
        },
        search() {
            const searchData = _.clone(this.searchData);
            if (this.searchChange.length !== 0) {
                this.searchChange.map(item => {
                    if (item.value !== item.startValue && item.value) {
                        delete searchData[item.endValue];
                    }
                });
            }
            const setSearchData = _.clone(this.setSearchData);
            const data = Object.assign({}, setSearchData, searchData);
            this.$emit('search', data);
            this.showPopover = false;
        },
        advanceCodeChange(num, current) {
            this.advanceType = num;
            this.currentSearchData[current.advanceCode] = '';
        },
        searchReset(searchDataIn = null, reset = false) {
            const searchData = searchDataIn || {};
            // 过滤有值的属性，只对未赋值的属性进行初始化
            this.searchSetList.filter(data => !searchData[data.value]).map(data => {
                if (reset || !this.initSearchInfo[data.value]) {
                    if (data.type === 'time' && data.timeNum) {
                        const start = dayjs().startOf('day').subtract(data.timeNum, 'd').toDate();
                        const end = dayjs().endOf('day').toDate();
                        searchData[data.value] = [start, end];
                    } else if (data.type === 'advance') {
                        if (this.keyMap[data.value]) {
                            this.keyMap[data.value].forEach(key => { searchData[key] = ''; });
                        } else {
                            searchData[data.value] = '';
                        }
                    } else {
                        let item = '';
                        if (data.data) {
                            item = data.data;
                        } else if (data.multiple) {
                            item = [];
                        }
                        let key = data.value;
                        if (data.passValue) {
                            this.searchChange.push({ startValue: data.ganged, endValue: data.value, value: data.passValue });
                            key = data.passValue;
                        }
                        searchData[key] = item;
                    }
                } else {
                    searchData[data.value] = this.initSearchInfo[data.value];
                }
            });
            this.searchData = searchData;
        },
        searchInit() {
            // 只保存弹窗上存在的元素的属性
            const searchData = this.searchSetList.map(data => {
                // 初始化keyMap
                if (data.type === 'advance' && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
                return data.value;
            }).reduce((result, prop) => {
                if (this.keyMap[prop]) {
                    this.keyMap[prop].forEach(key => {
                        result[key] = this.searchData[key];
                    });
                } else {
                    result[prop] = this.searchData[prop];
                }
                return result;
            }, {});
            this.searchReset(searchData);
        },
        userDetaliSearch(num, current) {
            this.advanceType = num;
            this.$refs.advanceUser.show(current);
        },
        // 高级弹框
        detaliSearch(num, current) {
            this.advanceType = num;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            let advanceCascade = {};
            if (_.isString(current.advanceCascade)) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.currentSearchData[sourceProp];
                });
            }
            // 配置额外的传参
            if (current.extraParams) {
                advanceCascade = { ...advanceCascade, ...current.extraParams }
            }
            const { mode, advanceRequire } = current;
            if (advanceRequire && advanceRequire.length > 0) {
                let flag = true;
                advanceRequire.forEach(ad => {
                    if (!this.currentSearchData[ad.prop]) {
                        flag = false;
                        this.$message.warning(ad.message);
                    }
                });
                if (!flag) { return false; }
            }
            this.$refs.advanceDialog.show(true, current, advanceCascade, mode);
        },
        detaliSearchSure(data) {
            // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
            const keyArr = Object.keys(data);
            if (keyArr.length > 0) {
                keyArr.forEach(key => {
                    this.keyMap[key] = keyArr;
                });
            }
            Object.assign(this.currentSearchData, data);
        },
        getSetList() {
            const menu = { subResources: _.clone(this.menus) };
            this.deepMenu(menu);
            let checkedList = '';
            const pramas = {
                subjectType: this.searchId,
                moduleCode: this.resourceCode
            };
            return getList.get(this.configurationUrl, pramas).then(data => {
                if (data.data) {
                    checkedList = data.data.configNameCn;
                    this.searchSetTitle = checkedList.split(',');
                } else {
                    this.searchSetTitle = [];
                }
            }).catch(() => {
                this.searchSetTitle = [];
            });
        },
        creatSearchList() {
            this.searchSetList = this.searchTotalTitle.map(item => {
                item.select = this.searchSetTitle.includes(item.name);
                return item;
            }).filter(item => item.select);
        },
        remoteMethod(query) {
            this.options = [];
            let searchData;
            if (query) {
                searchData = query.replace(/\s*/g, '');
            } else {
                searchData = '';
            }
            const params = {
                [this.selectItem.tableName]: {
                    [this.selectItem.value]: searchData,
                    [this.selectItem.ganged]: searchData
                }
            };
            if (this.selectItem.relevanceOne) {
                params[this.selectItem.tableName][this.selectItem.relevanceOne] = this.searchData[this.selectItem.relevanceOne];
            }
            if (this.selectItem.relevanceTwo) {
                params[this.selectItem.tableName][this.selectItem.relevanceTwo] = this.searchData[this.selectItem.relevanceTwo];
            }
            longRange(this.longPrefix, params).then(data => {
                const restaurants = [];
                data.data[this.selectItem.tableName].map(search => {
                    restaurants.push({ 'value': search[this.selectItem.ganged], 'label': search[this.selectItem.value] });
                });
                this.searchLoading = true;
                setTimeout(() => {
                    this.searchLoading = false;
                    this.options = restaurants.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(searchData.toLowerCase()) > -1;
                    });
                }, 20);
            });
        },
        searchDateChange(item) {
            this.selectItem = item;
            this.remoteMethod();
        },
        getOptionList() {
            this.searchTotalTitle.map(columns => {
                if (columns.optionNum) {
                    const params = {
                        dictCodes: columns.optionNum,
                        tenantCode: this.currentTenant.tenantCode
                    };
                    dict(this.popPrefix, params).then(data => {
                        const option = [];
                        for (const key in data.data[columns.optionNum]) {
                            if (data.data[columns.optionNum].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': data.data[columns.optionNum][key] });
                            }
                        }
                        columns.options = option;
                    });
                }
            });
        },
        initData() {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
                this.showState = false;
            });
        },
        selectedShow() {
            this.searchSetList = this.searchTotalTitle.filter(item => item.select);
            this.searchInit();
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams(prop) {
            if (this.keyMap[prop]) {
                const keyArr = this.keyMap[prop];
                // 把属性相关联的字段置空
                keyArr.forEach(key => {
                    this.currentSearchData[key] = '';
                });
            } else {
                this.currentSearchData[prop] = '';
            }
        }
    },
    created() {
        this.getOptionList();
        this.$eventBus.$on(this.$route.name, () => {
            this.showPopover = false;
        });
    },
    watch: {
    },
    computed: {
        ...mapGetters(['currentTenant', 'menus']),
        _() {
            return _;
        },
        searchList() {
            return [
                {
                    list: this.searchInitList,
                    data: this.setSearchData
                },
                {
                    list: this.searchSetList,
                    data: this.searchData
                }];
        },
        currentSearchData() {
            return this.advanceType === 0 ? this.setSearchData : this.searchData;
        }
    }
};

</script>
<style lang="less">
#search-set {
    .el-input__inner {
        padding: 3px 10px;
        height: 28px !important;
    }

    >ul {
        display: flex;
        flex-wrap: wrap;
    }

    .search-list-box {
        margin-top: 10px;

        >li {
            display: flex;
            margin-bottom: 10px;
            width: 410px;

            >span {
                display: inline-block;
                padding: 0 10px 0 0;
                width: 105px;
                height: 28px;
                text-align: right;
                line-height: 28px;
            }

            >div {
                width: 320px;

                >div{
                    width: 100%;
                }
            }

            .select-btn {
                color: #eee !important;
            }
        }
    }

    .line {
        width: 100%;
        height: 1px;
        background-color: #F2F2F2;
    }

    .search-total-box {
        display: flex;
        overflow: auto;
        max-height: 120px;
        flex-wrap: wrap;

        .el-button {
            color: #252626;
            border-color: #CECECE;
        }

        .is-select.el-button {
            color: #00BCBF;
            border-color: #00BCBF;
        }

        li {
            padding: 0 10px 10px 0;
            width: 162px;
        }
    }

    .btn-box {
        display: flex;
        justify-content: flex-end;
        width: 100%;

        .text-btn{
            width: 40%;
        }

        .btn-btn{
            display: flex;
            justify-content: flex-end;
            width: 60%;
        }
    }

    .btn-width {
        width: 162px;
    }

    .text-box{
        width: 100%;
        font-size: 12px;
    }

    .padding-for-prefix {
        .el-input__inner {
            padding-left: 25px;
        }
    }

    .date-picker-box{
        input{
            padding-left: 20px;
        }
    }

    .v-modal{
        z-index: 2000!important;
    }
}

.search-set_back {
    position: fixed;
    inset: 0;
    z-index: 1000;
    overflow: auto;
    margin: 0;
    // opacity: 0.5;
    // background: #000000;

}

</style>
